/**
 * Theme semantics for the SPA. The host owns the theme — it seeds the initial value via the
 * `?theme=` query param and pushes changes over the bridge's `context.update` event. The OS
 * `prefers-color-scheme` is deliberately never consulted; following it would let the widget
 * disagree with the host chrome it is embedded in.
 */
export type Theme = "light" | "dark";

export const DEFAULT_THEME: Theme = "light";

/** Narrow an untrusted value (URL param, host push) to a Theme; undefined when unrecognized. */
export function parseTheme(raw: string | null | undefined): Theme | undefined {
  return raw === "light" || raw === "dark" ? raw : undefined;
}

/** `index.html` sets this pre-paint; this keeps it in sync afterwards. */
export function applyTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
}
